import React, { useEffect, useRef } from 'react';
import '../styles/global_styles.css';
import Header  from '../components/Header';
import Hero from '../components/Hero';
import Asociate from '../components/Asociate';
import Servicios from '../components/Servicios';
import Planes from '../components/Planes';
import PreguntasFrecuentes from '../components/MostrarPreguntasFrecuentes';
import Contacto from '../components/Contacto';
import globalStore from '../store/global';
import { navigate } from "wouter/use-browser-location";
import { useLocation } from 'wouter';

type SeccionsRefs = {
  [key: string]: HTMLElement | null;
};

const Home = () => {

  const { seccion, setSeccion } = globalStore();

  const navegarA = (destino: string) => {
    setSeccion(destino);
    let seccionElement = document.getElementById(destino);
    if (seccionElement === null) return;
    seccionElement.scrollIntoView({ behavior: 'smooth' });
    
  };

  const seccionesRef = useRef<SeccionsRefs>({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setSeccion(entry.target.id);
          }
        });
      },
      { rootMargin: '0px 0px -20% 0px' }
    );

    const seccionElements = document.querySelectorAll('section');
    seccionElements.forEach((seccionElement) => {
      observer.observe(seccionElement);
      seccionesRef.current[seccionElement.id] = seccionElement;
    });

    return () => {
      seccionElements.forEach((seccionElement) => {
        observer.unobserve(seccionElement);
      });
    };
  }, []);
  
  const [location] = useLocation();

  useEffect(() => {
    if (location === '/') {
      const sectionId = window.location.hash;
      if (sectionId) {
        const sectionElement = document.querySelector(sectionId);
        if (sectionElement) {
          sectionElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }, [location]);
    
  return (
    <>
      <Header navegacionFija={true} seccionActual={seccion} cambiarSeccion={navegarA}></Header>
      <Hero id={'inicio'}></Hero>
      <Asociate id={'asociate'}></Asociate>
      <Servicios id={'servicios'}></Servicios>
      <Planes id={'planes'}></Planes>
      <Contacto id={'contacto'}></Contacto> 
    </>
  );
}

export default Home;

  /*useEffect(() => {
    
    window.addEventListener('scroll', () => {
      if (window.scrollY < 500) {
        setSeccion('inicio');
      } else if (window.scrollY < 1500) {
        setSeccion('asociate');
      } else if (window.scrollY < 2500) {
        setSeccion('servicios');
      } else if (window.scrollY < 3500) {
        setSeccion('planes');
      } else {
        setSeccion('contacto');
      }
    });
  }, [seccion]);*/

  //const [seccion, setSeccion] = useState('inicio');
